/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import AccountBox from "@material-ui/icons/AccountBox";
import AddBox from "@material-ui/icons/AddBox";
import Business from "@material-ui/icons/Business";
import Work from "@material-ui/icons/Work";
import Person from "@material-ui/icons/Person";
import Schedule from "@material-ui/icons/Schedule";
import AllInbox from "@material-ui/icons/AllInbox";
import Assessment from "@material-ui/icons/Assessment";
import GroupIcon from '@material-ui/icons/Group';
/*import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import Notifications from "@material-ui/icons/Notifications";*/
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import Company from "views/NewConnection/Company.js";
import Consumer from "views/NewConnection/Consumer.js";
import Trader from "views/NewConnection/Trader.js";
import InProgress from "./views/InProgress/InProgress";
import TeamOverview from "./views/TeamOverview/TeamOverview";
import Resources from "./views/Resources/Resources";
import Reports from "./views/Reports/Reports";
import UserProfile from "views/UserProfile/UserProfile.js";
/*import TableList from "views/TableList/TableList.js";
import Typography from "views/Typography/Typography.js";
import Icons from "views/Icons/Icons.js";*/
// Components/views for home layout
import Home from "views/Home/Home.js";
import Login from "views/Home/Login.js";
//import NotificationsPage from "views/Notifications/Notifications.js";

const dashboardRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: Dashboard,
    component: Home,
    layout: "/home",
    parent: "",
    hasChild: false
  },
  {
    path: "/login",
    name: "Login",
    icon: Dashboard,
    component: Login,
    layout: "/home",
    parent: "",
    hasChild: false
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin",
    parent: "",
    hasChild: false
  },
  {
    path: "/new/company",
    name: "Company",
    icon: Business,
    component: Company,
    layout: "/admin",
    parent: "/new",
    hasChild: false
  },
  {
    path: "/new/trader",
    name: "Sole Trader",
    icon: Work,
    component: Trader,
    layout: "/admin",
    parent: "/new",
    hasChild: false
  },
  {
    path: "/new/consumer",
    name: "Consumer",
    icon: Person,
    component: Consumer,
    layout: "/admin",
    parent: "/new",
    hasChild: false
  },
  {
    path: "/new",
    name: "New",
    icon: AddBox,
    component: Company,
    layout: "/admin",
    parent: "",
    hasChild: true
  },
  {
    path: "/in-progress",
    name: "In Progress",
    icon: Schedule,
    component: InProgress,
    layout: "/admin",
    parent: "",
    hasChild: false
  },
  {
    path: "/team-overview",
    name: "Team Overview",
    icon: GroupIcon,
    component: TeamOverview,
    layout: "/admin",
    parent: "",
    hasChild: false
  },
  {
    path: "/resources",
    name: "Resources",
    icon: AllInbox,
    component: Resources,
    layout: "/admin",
    parent: "",
    hasChild: false
  },
  {
    path: "/reports",
    name: "Reports",
    icon: Assessment,
    component: Reports,
    layout: "/admin",
    parent: "",
    hasChild: false
  },
  {
    path: "/user",
    name: "My Profile",
    icon: AccountBox,
    component: UserProfile,
    layout: "/admin",
    parent: "",
    hasChild: false
  }/*,
  {
    path: "/table",
    name: "Table List",
    icon: "content_paste",
    component: TableList,
    layout: "/admin",
    parent: "",
    hasChild: false
  },
  {
    path: "/typography",
    name: "Typography",
    icon: LibraryBooks,
    component: Typography,
    layout: "/admin",
    parent: "",
    hasChild: false
  },
  {
    path: "/icons",
    name: "Icons",
    icon: BubbleChart,
    component: Icons,
    layout: "/admin",
    parent: "",
    hasChild: false
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: Notifications,
    component: NotificationsPage,
    layout: "/admin",
    parent: "",
    hasChild: false
  }*/
];

export default dashboardRoutes;
